import AffirmationService from 'src/modules/affirmation/affirmationService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'AFFIRMATION_FORM';

const affirmationFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await AffirmationService.find(id);
      }

      dispatch({
        type: affirmationFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: affirmationFormActions.INIT_ERROR,
      });

      getHistory().push('/affirmation');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationFormActions.CREATE_STARTED,
      });

      const record = await AffirmationService.create(
        values,
      );

      dispatch({
        type: affirmationFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.affirmation.create.success'),
      );

      getHistory().push(`/affirmation/${record.id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: affirmationFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: affirmationFormActions.UPDATE_STARTED,
      });

      await AffirmationService.update(id, values);

      dispatch({
        type: affirmationFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.affirmation.update.success'),
      );

      getHistory().push(`/affirmation/${id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: affirmationFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default affirmationFormActions;
